import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '@environment/environment';
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class ExternalchangepasswordService {
  private baseUrl: string;
  
  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getUserservicebaseurl();
  }
  // Method to add new Internal/External users
  postPasswordDetails(passwordDetails: any): Observable<any> {

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/ChangePassword`, JSON.stringify(passwordDetails), options)
      .map(response => response as any)
      .catch(handleError);
  }

  isPasswordExists(userId: number, password: string): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/passwordExists`, JSON.stringify({ UserID: userId, newPassword: password }), options)
      .map(response => response as any)
      .catch(handleError);
  }


}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/externalchangepassword/Service/externalchangepassword.service.ts